export default __webpack_public_path__ + "img/Poppins-Regular_9c4f95b.ttf";